import { ISavePrintFormat, ISavePrintProfile } from "dto/Printing/IOutgoingPrint";

// Formularze edytorów formatu i profilu wydruku. Pola liczbowe są edytowane jako tekst
// i parsowane dopiero przy zapisie — przy polu sterowanym liczbą przecinek/kropka dziesiętna
// znikały w trakcie pisania („99," → „99"), więc „99,1 mm" nie dało się wpisać.

export const txt = (v?: number | null) => (v == null ? "" : String(v).replace(".", ","));

/** null = puste, undefined = niepoprawna liczba. Przecinek i kropka dziesiętna. */
export const parseNumber = (v: string): number | null | undefined => {
  const s = v.trim();
  if (s === "") return null;
  const n = Number(s.replace(",", "."));
  return Number.isFinite(n) ? n : undefined;
};

export type FormatNumberKey =
  | "WidthMm"
  | "HeightMm"
  | "SheetColumns"
  | "SheetRows"
  | "SheetMarginTopMm"
  | "SheetMarginLeftMm"
  | "SheetGapXMm"
  | "SheetGapYMm";

export type FormatForm = Omit<ISavePrintFormat, FormatNumberKey> & Record<FormatNumberKey, string>;
export type ProfileForm = Omit<ISavePrintProfile, "OffsetXMm" | "OffsetYMm"> & {
  OffsetXMm: string;
  OffsetYMm: string;
};

const FORMAT_NUMBER_KEYS: FormatNumberKey[] = [
  "WidthMm",
  "HeightMm",
  "SheetColumns",
  "SheetRows",
  "SheetMarginTopMm",
  "SheetMarginLeftMm",
  "SheetGapXMm",
  "SheetGapYMm",
];

export const toFormatForm = (f: ISavePrintFormat): FormatForm => {
  const form = { ...f } as unknown as FormatForm;
  FORMAT_NUMBER_KEYS.forEach((k) => {
    form[k] = txt(f[k]);
  });
  return form;
};

/** Format do zapisu albo null, gdy któraś liczba jest niepoprawna (kolumny/wiersze — całkowite). */
export const fromFormatForm = (form: FormatForm): ISavePrintFormat | null => {
  const values: Partial<Record<FormatNumberKey, number | null>> = {};
  for (const k of FORMAT_NUMBER_KEYS) {
    const v = parseNumber(form[k]);
    if (v === undefined) return null;
    if ((k === "SheetColumns" || k === "SheetRows") && v != null && !Number.isInteger(v)) return null;
    values[k] = v;
  }
  if (!values.WidthMm || !values.HeightMm) return null;
  return { ...form, ...values } as ISavePrintFormat;
};

export const toProfileForm = (p: ISavePrintProfile): ProfileForm => ({
  ...p,
  OffsetXMm: txt(p.OffsetXMm),
  OffsetYMm: txt(p.OffsetYMm),
});

export const fromProfileForm = (form: ProfileForm): ISavePrintProfile | null => {
  const x = parseNumber(form.OffsetXMm);
  const y = parseNumber(form.OffsetYMm);
  if (x === undefined || y === undefined) return null;
  return { ...form, OffsetXMm: x ?? 0, OffsetYMm: y ?? 0 };
};
